import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Download } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { Tooltip } from "@air/primitive-tooltip";
import { useBreakpointsContext } from "@air/provider-media-query";
import { memo, useCallback } from "react";
import { BoardStatsBar } from "~/_components/BoardStatsBar";
import { ToggleNestedItemsButton } from "~/_components/ToggleNestedItemsButton";
import { useFormatBoardStats } from "~/_hooks/useFormatBoardStats";
import { usePublicPermissions } from "~/components/PublicPermissionsProvider";
import { useIsFlattenedView } from "~/hooks/search/useIsFlattenedView";
import { useIsSearchActive } from "~/hooks/search/useIsSearchActive";
import { useDownloadPublicBoard } from "~/hooks/useDownloadPublicBoard";
import { useGetPublicBoardStats } from "~/swr-hooks/boards/useGetPublicBoardsStats";
import { canGenerateZip } from "~/utils/permissions/taskPermissions";
export const PublicBoardStatsBar = /*#__PURE__*/ memo((param)=>{
    let { boardId } = param;
    const { isFlattenedView } = useIsFlattenedView();
    const { permissions } = usePublicPermissions();
    const { downloadPublicBoard } = useDownloadPublicBoard();
    const { data } = useGetPublicBoardStats({
        boardId,
        includeDescendants: isFlattenedView
    });
    const { formatBoardStats } = useFormatBoardStats();
    const { isSearchActive } = useIsSearchActive();
    const { isAboveMediumScreen } = useBreakpointsContext();
    const isEmptyBoard = (data === null || data === void 0 ? void 0 : data.assetCount) === 0 && (data === null || data === void 0 ? void 0 : data.fileCount) === 0 && (data === null || data === void 0 ? void 0 : data.sizeBytes) === 0;
    const isDownloadVisible = canGenerateZip(permissions) && !!boardId;
    const onDownloadClick = useCallback(()=>{
        if (boardId) {
            downloadPublicBoard({
                boardId,
                trackLocation: "board-stats-bar"
            });
        }
    }, [
        boardId,
        downloadPublicBoard
    ]);
    return !isEmptyBoard && data ? /*#__PURE__*/ _jsx(BoardStatsBar, {
        actions: !isSearchActive && /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                isAboveMediumScreen && /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(ToggleNestedItemsButton, {}),
                        isDownloadVisible && /*#__PURE__*/ _jsx("div", {
                            className: "h-8 w-px bg-grey-4"
                        })
                    ]
                }),
                isDownloadVisible && /*#__PURE__*/ _jsx(Tooltip, {
                    label: "Download board",
                    children: /*#__PURE__*/ _jsx(IconButton, {
                        appearance: "ghost",
                        color: "grey",
                        icon: Download,
                        label: "Download board",
                        onClick: onDownloadClick
                    })
                })
            ]
        }),
        stats: formatBoardStats(data)
    }) : null;
});
PublicBoardStatsBar.displayName = "PublicBoardStatsBar";
